import { render, staticRenderFns } from "./OnboardingHeaderStepper.vue?vue&type=template&id=3752bc6b&"
import script from "./OnboardingHeaderStepper.vue?vue&type=script&lang=ts&"
export * from "./OnboardingHeaderStepper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports